import { render } from "./Five.vue?vue&type=template&id=f1fbbc1a&scoped=true"
import script from "./Five.vue?vue&type=script&lang=js"
export * from "./Five.vue?vue&type=script&lang=js"

import "./Five.vue?vue&type=style&index=0&id=f1fbbc1a&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1fbbc1a"]])

export default __exports__